import { Outlet, useParams } from 'react-router-dom'
import { Stack, Grid2 as Grid } from '@mui/material'
import { SPACING } from '@common/theme/spacing'
import { useGetStudyById } from '@study_setup/hooks/useStudyQueries'
import { useGetSubjectById } from '@features/study_details/Subjects/hooks/useStudySubjectsQueries'
import { BreadcrumbItem } from '@common/components/Breadcrumb'
import { RouteKeyEnum } from 'src/routes'
import SubjectDetailsTabs from './SubjectDetailsTabs'
import SubjectDetailsHeader from '../components/SubjectDetails/SubjectDetailsHeader'
import { CombinedPermissionsProvider } from '@auth/hooks/useCombinedPermissions'
import { BaseLayout } from '@common/components/layouts/BaseLayout'
import { SIZING } from '@common/theme/sizing'

export default function SubjectDetailsLayout() {
  const { studyId, subjectId } = useParams<{
    studyId: string
    subjectId: string
  }>()

  const { data: studyData } = useGetStudyById(studyId!)

  const {
    data: subjectData,
    isError,
    isLoading: isSubjectLoading,
  } = useGetSubjectById({
    study_id: studyId!,
    subject_id: subjectId!,
  })

  const renderBreadCrumbs = (): BreadcrumbItem[] => {
    return [
      {
        title: 'Home',
        route_key: RouteKeyEnum.HOME,
      },
      {
        title: studyData ? `${studyData.nickname} (${studyData.user_facing_study_id})` : '',
        route_key: RouteKeyEnum.STUDY_DETAILS,
        params: { studyId: studyId! },
      },
      {
        title: `Subject ${subjectData?.pseudo_id}`,
        route_key: RouteKeyEnum.SUBJECTS,
        params: { studyId: studyId! },
      },
    ]
  }

  if (isSubjectLoading) {
    return <div>Loading...</div>
  }

  if (isError) {
    return <div data-testid="error-message">Failed to load subject</div>
  }

  return (
    <CombinedPermissionsProvider studyId={studyId!}>
      <BaseLayout>
        <Grid container size={SIZING.gridSizeXxl} paddingX={SPACING.QCDetailsSpacing}>
          <Grid size={SIZING.gridSizeXxl}>
            <SubjectDetailsHeader breadcrumbs={renderBreadCrumbs()} subject={subjectData} />
            <SubjectDetailsTabs />
            <Stack spacing={SPACING.spacingLg} sx={{ paddingTop: SPACING.spacingLg }}>
              <Outlet />
            </Stack>
          </Grid>
        </Grid>
      </BaseLayout>
    </CombinedPermissionsProvider>
  )
}
